import { render } from "./ToggleControl.vue?vue&type=template&id=ffaf1cf2"
import script from "./ToggleControl.vue?vue&type=script&lang=js"
export * from "./ToggleControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__